/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GradingIcon = /*#__PURE__*/ createSvgIcon(
  'GradingIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M12.493 6.733v8.86H1.407V1.907h5.86M3.133 4.22h2.06M3.133 7.24h3.814M3.133 10.26h7.634M3.133 13.28h7.634" />
            <path d="M7.393 3.987L9.767 6.36l5.5-5.507" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M15.617 8.417v11.075H1.758V2.383h7.325M3.917 5.275h2.575M3.917 9.05h4.766M3.917 12.825h9.541M3.917 16.6h9.541"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
          <path
            d="M9.242 4.983l2.966 2.967 6.875-6.883"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M18.74 10.1v13.29H2.11V2.86h8.79M4.7 6.33h3.09M4.7 10.86h5.72M4.7 15.39h11.45M4.7 19.92h11.45"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
          <path
            d="M11.09 5.98l3.56 3.56 8.25-8.26"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
        </>
      ),
    },
  },
  false
);

export default GradingIcon;
